//eslint-disable
import React, { Fragment } from 'react';
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { ButtonGroup, Card, CardBody, CardTitle, Jumbotron, Tooltip } from 'reactstrap';
import { ArcaField } from '../../../code/ArcaField';
import { ArcaHttpClientGroup } from '../../../code/ArcaHttpClientGroup';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';
import { ArcaPageFieldState } from '../../../code/ArcaPageFieldState';
import { ArcaSecurity } from '../../../code/ArcaSecurity';
import { ArcaGroup } from '../../../code/Types/ArcaGroup';
import { FieldEdit } from '../../controls/Fields/FieldEdit';
import { ModalPopup } from '../../controls/ModalPopup';
import { PageLink } from '../../controls/Navigation/PageLink';
import { LoginPanel } from '../../controls/Security/LoginPanel';
import { StatusBar } from '../../controls/StatusBar';
import { ArcaComponent } from '../ArcaComponent';
import { GroupPanel2 } from './GroupPanel2';


export class GroupEditor2 extends ArcaComponent {

    constructor(props) {
        super(props);

        this.state = {
            editGroup: null,
            groups: null,
            editIsVisible: false,
            tooltipOpen: false,
            deleteConfirmVisible: false,
            selectedGroup: null,
            statusMessage: null,
            isError: false,
            formState: this.buildFields()
        };
    }

    async componentDidMount() {
        if (ArcaSecurity.IsLoggedIn)
            await this.getGroupList();
    }

    async getGroupList() {
        await ArcaHttpClientGroup.GetGroupsAsync(
            (groups => this.receivedGroupList(groups)),
            (status => alert(`GetGroupAsync returned ${status}`))
        );
    }

    receivedGroupList(groups) {
        this.setState({ groups: groups })
    }

    newWalkGroup() {
        this.setState({
            editGroup: new ArcaGroup(),
            editIsVisible: true
        });
    }

    toggleTooltip(k) {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    activityFilter = undefined
    filterData(group, filter, filterValue) {
        switch (filter) {

            case "ActivityType":
                this.activityFilter = filterValue
                break;

            default:
                return true;
        }

        return (this.activityFilter ? group.ActivityType === this.activityFilter : true)
    }

    render() {

        return (
            <Fragment>
                {!ArcaSecurity.IsLoggedIn
                    ? <LoginPanel onLogon={(() => this.getGroupList())} />
                    : <Fragment>
                        <h1>Walk Groups #2</h1>

                        <ButtonGroup>
                            <PageLink color="secondary" text='New Group' onClick={this.newWalkGroup.bind(this)} />
                        </ButtonGroup>
                        <div className='rounded px-3 px-sm-4 py-3 py-sm-5 pagePanel' fluid>
                            <h2>Filters</h2>
                            <Card>
                                <CardTitle>
                                </CardTitle>
                                <CardBody>
                                    {this.state.formState.Fields.map((f, k) =>
                                        <FieldEdit key={k} field={f} onUpdate={this.onUpdate.bind(this)} inline={!ArcaHttpSystem.IsSmartphone} canClear={true} />
                                    )}
                                </CardBody>
                            </Card>
                        </div>

                        <StatusBar message={this.state.statusMessage} isError={this.state.isError} />

                        {this.state.editIsVisible
                            ? <GroupPanel2
                                group={this.state.editGroup}
                                isVisible={this.state.editIsVisible}
                                onConfirm={() => {
                                    this.setState({ editIsVisible: false });
                                    this.getGroupList();
                                }}
                                onCancel={() => {
                                    this.setState({ editIsVisible: false });
                                    this.getGroupList();
                                }} />
                            : null}

                        <table className='table table-striped' aria-labelledby="tabelLabel">
                            <thead>
                                <tr>
                                    <th>Act.</th>
                                    <th>Dogs</th>
                                    <th id='actionIcon'>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.groups?.filter(g => this.filterData(g, this.state.filter, this.state.filterValue)).map((g, k) =>
                                    <tr key={k}>
                                        <td>{g.ActivityType}</td>
                                        <td>{g.PetList.map((p, k) => <Fragment key={k}> {p}<br /> </Fragment>)}</td>
                                        <td>
                                            <FaEdit
                                                style={{ color: 'darkblue', cursor: 'pointer' }}
                                                size={'28'}
                                                onClick={this.onEditClick.bind(this, g)}
                                            />{'  '}
                                            <MdDelete
                                                style={{ color: 'darkred', cursor: 'pointer' }}
                                                size={'28'}
                                                onClick={this.onDeleteClick.bind(this, g)} />
                                        </td>
                                    </tr>
                                )}

                            </tbody>
                        </table>

                        <Tooltip placement="right" isOpen={this.state.tooltipOpen} target={'actionIcon'} toggle={this.toggleTooltip.bind(this)}>
                            Delete or Edits the item on this row!
                        </Tooltip>

                        {this.state.deleteConfirmVisible ?
                            <ModalPopup
                                title={`Deletion of a walk group`}
                                text={`Are you sure you wish to delete this group '${this.state.selectedGroup.ToString()}'`}
                                onConfirm={this.onDeleteConfirm.bind(this, this.state.selectedGroup)}
                                onCancel={(() => this.setState({ deleteConfirmVisible: false }))}
                            />
                            : null}

                    </Fragment>}
            </Fragment>
        );
    }

    onUpdate(value, isValid, fieldName) {
        this.state.formState.GetField('ActivityType').Value = '';

        this.state.formState.GetField(fieldName).Value = value ?? '';
        let filter = fieldName;

        this.setState({
            formState: this.state.formState,
            Fields: this.state.formState.Fields,
            filter: filter,
            filterValue: value
        });
    }

    buildFields() {
        var formState = new ArcaPageFieldState();
        formState.AddField(new ArcaField("Activity", "ActivityType", "", true, false, 'select', 'ActivityType'));

        return formState;
    }

    onEditClick(editGroup) {
        this.setState({
            editGroup: editGroup,
            editIsVisible: true
        });
    }

    async onDeleteClick(deleteGroup) {
        this.setState({
            deleteConfirmVisible: true,
            selectedGroup: deleteGroup
        });
    }

    async onDeleteConfirm(deleteGroup) {
        await ArcaHttpClientGroup.DeleteGroupAsync(deleteGroup,
            (() => {
                this.setState({
                    selectedGroup: null,
                    deleteConfirmVisible: false,
                    groups: this.state.groups.filter(g => g.Id !== deleteGroup.Id)
                });
            }),
            ((status) =>
                this.setState({
                    statusMessage: `Deletion failed with a status of ${status}`,
                    isError: true
                })))
    }
}